import { createContext, useContext } from 'react'

import { OnCountryDataFieldChange } from 'modules/contracts/lib/useCountryDataInputs'

interface CountryDataInputsContextValue {
  updateCountryDataField: OnCountryDataFieldChange
}

const CountryDataInputsContext = createContext<CountryDataInputsContextValue | null>(null)

export const CountryDataInputsProvider = CountryDataInputsContext.Provider

export const useCountryDataFieldChange = () => {
  const ctx = useContext(CountryDataInputsContext)
  return ctx?.updateCountryDataField
}
